// extracted by mini-css-extract-plugin
export default {"divButton":"style_divButton__T3fB4"};